import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as addPlanzoneMaterialResource from "./addPlanzoneMaterialResource";
import * as addPlanzoneVirtualResource from "./addPlanzoneVirtualResource";
import * as addProjectMaterialResource from "./addProjectMaterialResource";
import * as addProjectVirtualResource from "./addProjectVirtualResource";
import * as removeResourceFromProject from "./removeResourceFromProject";
import * as addPlanzoneResourceToProject from "./addPlanzoneResourceToProject";
import * as addPlanzoneResourcesToProject from "./addPlanzoneResourcesToProject";
import * as addEveryoneToProject from "./addEveryoneToProject";
import * as assignEveryoneToManager from "./assignEveryoneToManager";
import * as removeSubordinates from "./removeSubordinates";
import * as removeResourceFromPlanzone from "./removeResourceFromPlanzone";
import * as editResource from "./editResource";
import * as editProjectResource from "./editProjectResource";
import * as retrieveResource from "./retrieveResource";
import * as retrievePlanzoneResources from "./retrievePlanzoneResources";
import * as retrieveZoneResources from "./retrieveZoneResources";
import * as retrieveProjectResources from "./retrieveProjectResources";
import * as editResourceWeeklyCalendar from "./editResourceWeeklyCalendar";
import * as retrieveResourceProjects from "./retrieveResourceProjects";
import * as assignManagerToResource from "./assignManagerToResource";
import * as unAssignManagerFromResource from "./unAssignManagerFromResource";
import * as retrieveResourceSubordinates from "./retrieveResourceSubordinates";
import * as retrievePlanzoneResourcesListing from "./retrievePlanzoneResourcesListing";
import * as retrieveProjectResourcesListing from "./retrieveProjectResourcesListing";
import * as retrieveFilterResources from "./retrieveFilterResources";
import * as retrieveResourcesByUuids from "./retrieveResourcesByUuids";
import * as retrievePlanzoneResourcesCounts from "./retrievePlanzoneResourcesCounts";
import * as assignCalendarHolidaysToResource from "./assignCalendarHolidaysToResource";
import * as retrieveResourceCalendarHolidays from "./retrieveResourceCalendarHolidays";
import * as disableProjectResource from "./disableProjectResource";
import * as activateProjectResource from "./activateProjectResource";
import * as disableResource from "./disableResource";
import * as activateResource from "./activateResource";
import * as unAssignCalendarHolidaysFromResource from "./unAssignCalendarHolidaysFromResource";
import * as addPlanzoneResourceToProjects from "./addPlanzoneResourceToProjects";
import * as changeProfilePicture from "./changeProfilePicture";
import * as retrieveProjectResourceAllocations from "./retrieveProjectResourceAllocations";
import * as transferProjectResourceAllocations from "./transferProjectResourceAllocations";

const initialState: State = {
  editProjectResource: editProjectResource.initialState,
  editResource: editResource.initialState,
  removeResourceFromProject: removeResourceFromProject.initialState,
  addPlanzoneMaterialResource: addPlanzoneMaterialResource.initialState,
  addPlanzoneVirtualResource: addPlanzoneVirtualResource.initialState,
  addProjectMaterialResource: addProjectMaterialResource.initialState,
  addProjectVirtualResource: addProjectVirtualResource.initialState,
  addPlanzoneResourceToProject: addPlanzoneResourceToProject.initialState,
  addPlanzoneResourcesToProject: addPlanzoneResourcesToProject.initialState,
  addEveryoneToProject: addEveryoneToProject.initialState,
  assignEveryoneToManager: assignEveryoneToManager.initialState,
  removeSubordinates: removeSubordinates.initialState,
  removeResourceFromPlanzone: removeResourceFromPlanzone.initialState,
  retrieveResource: retrieveResource.initialState,
  retrievePlanzoneResources: retrievePlanzoneResources.initialState,
  retrieveZoneResources: retrieveZoneResources.initialState,
  retrieveProjectResources: retrieveProjectResources.initialState,
  editResourceWeeklyCalendar: editResourceWeeklyCalendar.initialState,
  retrieveResourceProjects: retrieveResourceProjects.initialState,
  assignManagerToResource: assignManagerToResource.initialState,
  unAssignManagerFromResource: unAssignManagerFromResource.initialState,
  retrieveResourceSubordinates: retrieveResourceSubordinates.initialState,
  retrievePlanzoneResourcesListing:
    retrievePlanzoneResourcesListing.initialState,
  retrieveProjectResourcesListing: retrieveProjectResourcesListing.initialState,
  retrieveFilterResources: retrieveFilterResources.initialState,
  retrieveResourcesByUuids: retrieveResourcesByUuids.initialState,
  retrievePlanzoneResourcesCounts: retrievePlanzoneResourcesCounts.initialState,
  assignCalendarHolidaysToResource:
    assignCalendarHolidaysToResource.initialState,
  retrieveResourceCalendarHolidays:
    retrieveResourceCalendarHolidays.initialState,
  disableProjectResource: disableProjectResource.initialState,
  activateProjectResource: activateProjectResource.initialState,
  disableResource: disableResource.initialState,
  activateResource: activateResource.initialState,
  unAssignCalendarHolidaysFromResource:
    unAssignCalendarHolidaysFromResource.initialState,
  addPlanzoneResourceToProjects: addPlanzoneResourceToProjects.initialState,
  changeProfilePicture: changeProfilePicture.initialState,
  retrieveProjectResourceAllocations:
    retrieveProjectResourceAllocations.initialState,
  transferProjectResourceAllocations:
    transferProjectResourceAllocations.initialState,
};

const reduceState = combineStateReducer(initialState, {
  addPlanzoneMaterialResource: addPlanzoneMaterialResource.reduceState,
  addPlanzoneVirtualResource: addPlanzoneVirtualResource.reduceState,
  addProjectMaterialResource: addProjectMaterialResource.reduceState,
  addProjectVirtualResource: addProjectVirtualResource.reduceState,
  removeResourceFromProject: removeResourceFromProject.reduceState,
  addPlanzoneResourceToProject: addPlanzoneResourceToProject.reduceState,
  addPlanzoneResourcesToProject: addPlanzoneResourcesToProject.reduceState,
  addEveryoneToProject: addEveryoneToProject.reduceState,
  assignEveryoneToManager: assignEveryoneToManager.reduceState,
  removeSubordinates: removeSubordinates.reduceState,
  removeResourceFromPlanzone: removeResourceFromPlanzone.reduceState,
  editResource: editResource.reduceState,
  editProjectResource: editProjectResource.reduceState,
  retrieveResource: retrieveResource.reduceState,
  retrievePlanzoneResources: retrievePlanzoneResources.reduceState,
  retrieveZoneResources: retrieveZoneResources.reduceState,
  retrieveProjectResources: retrieveProjectResources.reduceState,
  editResourceWeeklyCalendar: editResourceWeeklyCalendar.reduceState,
  retrieveResourceProjects: retrieveResourceProjects.reduceState,
  assignManagerToResource: assignManagerToResource.reduceState,
  unAssignManagerFromResource: unAssignManagerFromResource.reduceState,
  retrieveResourceSubordinates: retrieveResourceSubordinates.reduceState,
  retrievePlanzoneResourcesListing:
    retrievePlanzoneResourcesListing.reduceState,
  retrieveProjectResourcesListing: retrieveProjectResourcesListing.reduceState,
  retrieveFilterResources: retrieveFilterResources.reduceState,
  retrieveResourcesByUuids: retrieveResourcesByUuids.reduceState,
  retrievePlanzoneResourcesCounts: retrievePlanzoneResourcesCounts.reduceState,
  assignCalendarHolidaysToResource:
    assignCalendarHolidaysToResource.reduceState,
  retrieveResourceCalendarHolidays:
    retrieveResourceCalendarHolidays.reduceState,
  disableProjectResource: disableProjectResource.reduceState,
  activateProjectResource: activateProjectResource.reduceState,
  disableResource: disableResource.reduceState,
  activateResource: activateResource.reduceState,
  unAssignCalendarHolidaysFromResource:
    unAssignCalendarHolidaysFromResource.reduceState,
  addPlanzoneResourceToProjects: addPlanzoneResourceToProjects.reduceState,
  changeProfilePicture: changeProfilePicture.reduceState,
  retrieveProjectResourceAllocations:
    retrieveProjectResourceAllocations.reduceState,
  transferProjectResourceAllocations:
    transferProjectResourceAllocations.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...addPlanzoneMaterialResource.createSelector(
      () => getState().addPlanzoneMaterialResource,
    ),
    ...addPlanzoneVirtualResource.createSelector(
      () => getState().addPlanzoneVirtualResource,
    ),
    ...addProjectMaterialResource.createSelector(
      () => getState().addProjectMaterialResource,
    ),
    ...addProjectVirtualResource.createSelector(
      () => getState().addProjectVirtualResource,
    ),
    ...removeResourceFromProject.createSelector(
      () => getState().removeResourceFromProject,
    ),
    ...addPlanzoneResourceToProject.createSelector(
      () => getState().addPlanzoneResourceToProject,
    ),
    ...addPlanzoneResourcesToProject.createSelector(
      () => getState().addPlanzoneResourcesToProject,
    ),
    ...addEveryoneToProject.createSelector(
      () => getState().addEveryoneToProject,
    ),
    ...assignEveryoneToManager.createSelector(
      () => getState().assignEveryoneToManager,
    ),
    ...removeSubordinates.createSelector(() => getState().removeSubordinates),
    ...removeResourceFromPlanzone.createSelector(
      () => getState().removeResourceFromPlanzone,
    ),
    ...editResource.createSelector(() => getState().editResource),
    ...editProjectResource.createSelector(() => getState().editProjectResource),
    ...retrieveResource.createSelector(() => getState().retrieveResource),
    ...retrievePlanzoneResources.createSelector(
      () => getState().retrievePlanzoneResources,
    ),
    ...retrieveZoneResources.createSelector(
      () => getState().retrieveZoneResources,
    ),
    ...retrieveProjectResources.createSelector(
      () => getState().retrieveProjectResources,
    ),
    ...editResourceWeeklyCalendar.createSelector(
      () => getState().editResourceWeeklyCalendar,
    ),
    ...retrieveResourceProjects.createSelector(
      () => getState().retrieveResourceProjects,
    ),
    ...assignManagerToResource.createSelector(
      () => getState().assignManagerToResource,
    ),
    ...unAssignManagerFromResource.createSelector(
      () => getState().unAssignManagerFromResource,
    ),
    ...retrieveResourceSubordinates.createSelector(
      () => getState().retrieveResourceSubordinates,
    ),
    ...retrievePlanzoneResourcesListing.createSelector(
      () => getState().retrievePlanzoneResourcesListing,
    ),
    ...retrieveProjectResourcesListing.createSelector(
      () => getState().retrieveProjectResourcesListing,
    ),
    ...retrieveFilterResources.createSelector(
      () => getState().retrieveFilterResources,
    ),
    ...retrieveResourcesByUuids.createSelector(
      () => getState().retrieveResourcesByUuids,
    ),
    ...retrievePlanzoneResourcesCounts.createSelector(
      () => getState().retrievePlanzoneResourcesCounts,
    ),
    ...assignCalendarHolidaysToResource.createSelector(
      () => getState().assignCalendarHolidaysToResource,
    ),
    ...retrieveResourceCalendarHolidays.createSelector(
      () => getState().retrieveResourceCalendarHolidays,
    ),
    ...disableProjectResource.createSelector(
      () => getState().disableProjectResource,
    ),
    ...activateProjectResource.createSelector(
      () => getState().activateProjectResource,
    ),
    ...disableResource.createSelector(() => getState().disableResource),
    ...activateResource.createSelector(() => getState().activateResource),
    ...unAssignCalendarHolidaysFromResource.createSelector(
      () => getState().unAssignCalendarHolidaysFromResource,
    ),
    ...addPlanzoneResourceToProjects.createSelector(
      () => getState().addPlanzoneResourceToProjects,
    ),
    ...changeProfilePicture.createSelector(
      () => getState().changeProfilePicture,
    ),
    ...retrieveProjectResourceAllocations.createSelector(
      () => getState().retrieveProjectResourceAllocations,
    ),
    ...transferProjectResourceAllocations.createSelector(
      () => getState().transferProjectResourceAllocations,
    ),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
